module.exports = ".scholarship-overview {\r\n  background: white;\r\n  padding: 15px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.scholarship-overview .number {\r\n  color: cornflowerblue;\r\n  font-size: 3rem;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/scholership-report/scholership-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/scholership-report/scholership-report.component.css
// module chunks = main